<template>
  <div class="main">
    <div class="site-chart">
      <p class="t12 centerS">
        <span>系统访问量统计</span>
        <span class="all-p">总访问量：
          <span>{{num1}}</span>
          次
        </span>
      </p>
      <Query @updata="updata1"/>
      <div id="syschart" class="chart1"></div>
    </div>
    <div class="site-chart">
      <p class="t12 centerS">
        <span>各省访问量统计</span>
        <span class="all-p">总访问量：
          <span>{{num2}}</span>
          次
        </span>
      </p>
      <QueryFWL @updata="updata2"/>
      <div id="chart2" class="chart1"></div>
    </div>
    <div class="site-chart">
      <p class="t12 centerS">
        <span>卫星数据下载量统计</span>
        <span class="all-p">总下载量：
          <span>{{num3}}</span>
          GB
        </span>
      </p>
      <Query @updata="updata3"/>
      <div id="satellite" class="chart1"></div>
    </div>
    <div class="site-chart">
      <p class="t12 centerS">
        <span>产品数据下载量统计</span>
        <span class="all-p">总下载量：
          <span>{{num4}}</span>
          GB
        </span>
      </p>
      <Query @updata="updata4"/>
      <div id="product" class="chart1"></div>
    </div>
  </div>
</template>

<script>
var date = new Date();
import Query from "./query.vue"
import QueryFWL from "./queryFWL.vue"
import * as echarts from 'echarts';

import {
  getSysRecord,
  getSysAccessIp,
  getSumStFileUsage,
  getSumProdFileUsage
} from "@/api/log/index"
export default {
  components:{
    Query,
    QueryFWL
  },
  data(){
    return{
      chartDom1:null,
      chartDom2:null,
      chartDom3:null,
      chartDom4:null,
      num1:0,
      num2:0,
      num3:0,
      num4:0,
      chartForm1:{
        timeType:1,
        month:'',
        year:date.getFullYear().toString()
      },
      chartForm2:{
        timeType:2,
        month:'',
        year:date.getFullYear().toString()
      },
      chartForm3:{
        timeType:1,
        month:'',
        year:date.getFullYear().toString()
      },
      chartForm4:{
        timeType:1,
        month:'',
        year:date.getFullYear().toString()
      }
    }
  },
  created(){
    this.getall1()
    this.getall2()
    this.getall3()
    this.getall4()
  },
  mounted(){
    this.initChart1()
    this.initChart2()
    this.initChart3()
    this.initChart4()

    this.getChart1Data()
    this.getChart2Data()
    this.getChart3Data()
    this.getChart4Data()
  },
  methods:{
    async getall1(){
      let res = await getSysRecord({timeType:-1})
      this.num1 = res[0].y
    },
    async getall2(){
      let res = await getSysAccessIp({timeType:-1})
      let sumN = 0
      res.forEach(element => {
        sumN = sumN + parseInt(element.y)
      });
      this.num2 = sumN
    },
    async getall3(){
      let res = await getSumStFileUsage({timeType:-1})
      this.num3 = res[0].y
      this.num3 = parseFloat(this.num3).toFixed(2)
    },
    async getall4(){
      let res = await getSumProdFileUsage({timeType:-1})
      this.num4 = res[0].y
      this.num4 = parseFloat(this.num4).toFixed(2)
    },



    updata1(val){
      let key
      let q_year = ''
      let q_month = ''
      
      q_year
      q_month

      switch (val.type) {
        case 3:
          key = 0
          q_year = val.timeM?val.timeM.slice(0,4):''
          q_month = val.timeM?val.timeM.slice(5,7):''
          break;
        case 6:
          key = 1
          q_year = val.timeY?val.timeY:''
          q_month= ''
          break;
      
        default:
          key = 2
          q_year = ''
          q_month= ''
          break;
      }
      this.chartForm1 = {
        timeType:key,
        month:q_month,
        year:q_year
      }
      this.getChart1Data()
    },
    updata2(val){
      let key
      let q_year = ''
      let q_month = ''
      
      q_year
      q_month

      switch (val.type) {
        case 3:
          key = 1
          q_year = val.timeM?val.timeM.slice(0,4):''
          q_month = val.timeM?val.timeM.slice(5,7):''
          break;
        case 6:
          key = 2
          q_year = val.timeY?val.timeY:''
          q_month= ''
          break;
      
        default:
          key = -1
          q_year = ''
          q_month= ''
          break;
      }
      this.chartForm2 = {
        timeType:key,
        month:q_month,
        year:q_year
      }
      this.getChart2Data()
    },
    updata3(val){
      let key
      let q_year = ''
      let q_month = ''
      
      q_year
      q_month

      switch (val.type) {
        case 3:
          key = 0
          q_year = val.timeM?val.timeM.slice(0,4):''
          q_month = val.timeM?val.timeM.slice(5,7):''
          break;
        case 6:
          key = 1
          q_year = val.timeY?val.timeY:''
          q_month= ''
          break;
      
        default:
          key = 2
          q_year = ''
          q_month= ''
          break;
      }
      this.chartForm3 = {
        timeType:key,
        month:q_month,
        year:q_year
      }
      this.getChart3Data()
    },
    updata4(val){
      let key
      let q_year = ''
      let q_month = ''
      
      q_year
      q_month

      switch (val.type) {
        case 3:
          key = 0
          q_year = val.timeM?val.timeM.slice(0,4):''
          q_month = val.timeM?val.timeM.slice(5,7):''
          break;
        case 6:
          key = 1
          q_year = val.timeY?val.timeY:''
          q_month= ''
          break;
      
        default:
          key = 2
          q_year = ''
          q_month= ''
          break;
      }
      this.chartForm4 = {
        timeType:key,
        month:q_month,
        year:q_year
      }
      this.getChart4Data()
    },

    async getChart1Data(){
      let res = await getSysRecord(this.chartForm1)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          },
          formatter : function(params) {
            return params[0].name + '/' + params[0].data + '次'
          }
        },
        color: ['#5DC0FF'],
        xAxis: {
          type: 'category',
          data: res.map(item => {return item.x})
        },
        yAxis: {
          name:'单位：次',
          type: 'value'
        },
        series: [
          {
            data: res.map(item => {return item.y}),
            type: 'bar',
            barWidth : 12,
            itemStyle:{
              normal:{
                barBorderRadius:[50,50,50,50]
              }
            }
          }
        ]
      };
      this.chartDom1.setOption(option)
    },
    async getChart2Data(){
      let res = await getSysAccessIp(this.chartForm2)
      let data = []
      res.forEach(element => {
        if(parseInt(element.y)>0){
          data.push({ value: parseInt(element.y), name: element.x })
        }
      });
      let option = {
        color:[
          'rgba(255, 103, 38, 1)',
          'rgba(47, 169, 37, 1)',
          'rgba(37, 184, 181, 1)',
          'rgba(22, 141, 221, 1)',
          'rgba(57, 126, 252, 1)',
          'rgba(128, 107, 255, 1)',
          'rgba(253, 92, 158, 1)',
          'rgba(255, 126, 61, 1)',
          'rgba(74, 186, 84, 1)',
          'rgba(40, 199, 188, 1)',
          'rgba(56, 163, 235, 1)',
          'rgba(91, 149, 255, 1)',
          'rgba(149, 131, 255, 1)',
          'rgba(255, 120, 175, 1)',
          'rgba(255, 146, 51, 1)',
          'rgba(94, 204, 82, 1)',
          'rgba(86, 214, 193, 1)',
          'rgba(98, 192, 255, 1)',
          'rgba(130, 174, 255, 1)',
          'rgba(174, 160, 255, 1)',
          'rgba(255, 159, 198, 1)',
          'rgba(255, 175, 25, 1)',
          'rgba(110, 219, 88, 1)',
          'rgba(115, 230, 203, 1)',
          'rgba(120, 228, 255, 1)',
          'rgba(157, 196, 255, 1)',
          'rgba(200, 187, 255, 1)',
          'rgba(255, 181, 207, 1)',
          'rgba(255, 207, 51, 1)',
          'rgba(166, 240, 81, 1)',
          'rgba(108, 245, 199, 1)',
          'rgba(155, 237, 255, 1)',
          'rgba(181, 225, 255, 1)',
          'rgba(217, 209, 255, 1)',
          'rgba(255, 209, 225, 1)',
        ],
        title: {
          subtext: '单位：次',
          left: 'left'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          top:'7%'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            center:['33%','52%'],
            data: data,
            label:{
              formatter: '{b}: {c}'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      this.chartDom2.setOption(option)
    },
    async getChart3Data(){
      let res = await getSumStFileUsage(this.chartForm3)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: false
            }
          },
          formatter : function(params) {
            return params[0].name + '<br/>' +'<span style="color:rgba(95, 163, 255, 1);">'+params[0].data+'<span/>' + 'GB'
          }
        },
        xAxis: {
          type: 'category',
          data: res.map(item => {return item.x})
        },
        yAxis: {
          name:'单位：GB',
          type: 'value'
        },
        series: [
          {
            data: res.map(item => {return parseFloat(item.y).toFixed(2)}),
            type: 'line',
            showSymbol:false,
            lineStyle: {
                color: '#5DC0FF'
              },
            areaStyle: {normal: {
              color: new echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                          {offset: 0, color: 'rgba(93, 162, 255, 0.2)'},
                          {offset: 1, color: 'rgba(93, 192, 255, 0.1)'}
                      ]
              )
            }},
          }
        ]
      };
      this.chartDom3.setOption(option)
    },
    async getChart4Data(){
      let res = await getSumProdFileUsage(this.chartForm4)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: false
            }
          },
          formatter : function(params) {
            return params[0].name + '<br/>' +'<span style="color:rgba(95, 163, 255, 1);">'+params[0].data+'<span/>' + 'GB'
          }
        },
        xAxis: {
          type: 'category',
          data: res.map(item => {return item.x})
        },
        yAxis: {
          name:'单位：GB',
          type: 'value'
        },
        series: [
          {
            data: res.map(item => {return parseFloat(item.y).toFixed(2)}),
            type: 'line',
            showSymbol:false,
            lineStyle: {
                color: '#5DC0FF'
              },
            areaStyle: {normal: {
              color: new echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                          {offset: 0, color: 'rgba(93, 162, 255, 0.2)'},
                          {offset: 1, color: 'rgba(93, 192, 255, 0.1)'}
                      ]
              )
            }},
          }
        ]
      };
      this.chartDom4.setOption(option)
    },



    initChart1(){
      this.chartDom1 = echarts.init(document.getElementById('syschart'));
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          },
          formatter : function(params) {
            return params[0].name + '/' + params[0].data + '次'
          }
        },
        color: ['#5DC0FF'],
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun','Mon', 'Tue', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          name:'单位：次',
          type: 'value'
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130,80,150, 80, 70, 110],
            type: 'bar',
            barWidth : 12,
            itemStyle:{
              normal:{
                barBorderRadius:[50,50,50,50]
              }
            }
          }
        ]
      };
      this.chartDom1.setOption(option)
    },
    initChart2(){
      this.chartDom2 = echarts.init(document.getElementById('chart2'));
      let option = {
        color:[
          'rgba(255, 103, 38, 1)',
          'rgba(47, 169, 37, 1)',
          'rgba(37, 184, 181, 1)',
          'rgba(22, 141, 221, 1)',
          'rgba(57, 126, 252, 1)',
          'rgba(128, 107, 255, 1)',
          'rgba(253, 92, 158, 1)',
          'rgba(255, 126, 61, 1)',
          'rgba(74, 186, 84, 1)',
          'rgba(40, 199, 188, 1)',
          'rgba(56, 163, 235, 1)',
          'rgba(91, 149, 255, 1)',
          'rgba(149, 131, 255, 1)',
          'rgba(255, 120, 175, 1)',
          'rgba(255, 146, 51, 1)',
          'rgba(94, 204, 82, 1)',
          'rgba(86, 214, 193, 1)',
          'rgba(98, 192, 255, 1)',
          'rgba(130, 174, 255, 1)',
          'rgba(174, 160, 255, 1)',
          'rgba(255, 159, 198, 1)',
          'rgba(255, 175, 25, 1)',
          'rgba(110, 219, 88, 1)',
          'rgba(115, 230, 203, 1)',
          'rgba(120, 228, 255, 1)',
          'rgba(157, 196, 255, 1)',
          'rgba(200, 187, 255, 1)',
          'rgba(255, 181, 207, 1)',
          'rgba(255, 207, 51, 1)',
          'rgba(166, 240, 81, 1)',
          'rgba(108, 245, 199, 1)',
          'rgba(155, 237, 255, 1)',
          'rgba(181, 225, 255, 1)',
          'rgba(217, 209, 255, 1)',
          'rgba(255, 209, 225, 1)',
        ],
        title: {
          subtext: '单位：次',
          left: 'left'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          top:'20%'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            data: [
              { value: 1048, name: '北京' },
              { value: 735, name: '四川' },
              { value: 580, name: '广东' },
              { value: 484, name: '上海' },
            ],
            label:{
              formatter: '{b}: {c}'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      
      this.chartDom2.setOption(option)
    },
    initChart3(){
      this.chartDom3 = echarts.init(document.getElementById('satellite'));
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: false
            }
          },
          formatter : function(params) {
            return params[0].name + '<br/>' +'<span style="color:rgba(95, 163, 255, 1);">'+params[0].data+'<span/>' + 'GB'
          }
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          name:'单位：GB',
          type: 'value'
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: 'line',
            showSymbol:false,
            lineStyle: {
                color: '#5DC0FF'
              },
            areaStyle: {normal: {
              color: new echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                          {offset: 0, color: 'rgba(93, 162, 255, 0.2)'},
                          {offset: 1, color: 'rgba(93, 192, 255, 0.1)'}
                      ]
              )
            }},
          }
        ]
      };
      this.chartDom3.setOption(option)
    },
    initChart4(){
      this.chartDom4 = echarts.init(document.getElementById('product'));
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: false
            }
          },
          formatter : function(params) {
            return params[0].name + '<br/>' +'<span style="color:rgba(95, 163, 255, 1);">'+params[0].data+'<span/>' + 'GB'
          }
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          name:'单位：GB',
          type: 'value'
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: 'line',
            showSymbol:false,
            lineStyle: {
                color: '#5DC0FF'
              },
            areaStyle: {normal: {
              color: new echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                          {offset: 0, color: 'rgba(93, 162, 255, 0.2)'},
                          {offset: 1, color: 'rgba(93, 192, 255, 0.1)'}
                      ]
              )
            }},
          }
        ]
      };
      
      this.chartDom4.setOption(option)
    },
  }
}
</script>

<style lang="scss" scoped>
.all-p{
  font-size: 14px;
  font-weight: 400;
}
.main{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .site-chart{
    width: 49%;
    height: 457px;
    margin-bottom: 12px;
  }
  .chart1{
    width: 100%;
    height: calc(100% - 100px);
  }
}
.t12{
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #2F2F2F;
  margin: 12px 0;
}
</style>